import { render } from "./AntrianMode.vue?vue&type=template&id=12431e54"
import script from "./AntrianMode.vue?vue&type=script&lang=js"
export * from "./AntrianMode.vue?vue&type=script&lang=js"

import "./AntrianMode.vue?vue&type=style&index=0&id=12431e54&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__